import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../../services/PremissionChecker";
function DefineSection() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const getBranchUrl = localStorage.getItem("branchUrl");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [sectionsData, setSectionsData] = useState([]);
  const [addSectionLoading, setAddSectionLoading] = useState(false);

  const [addSectionModal, setAddSectionModal] = useState(false);
  const [sectionName, setSectionName] = useState("");

  const [editSectionModal, setEditSectionModal] = useState(false);
  const [editSectionName, setEditSectionName] = useState("");
  const [editSectionId, setEditSectionId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteSectionId, setDeleteSectionId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getSections();
  }, []);

  const getSections = async () => {
    setloading(true);
    await fetch(`${baseUrl}/global-section`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setSectionsData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addSectionHandler = async () => {
    if (sectionName == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      name: sectionName,
    };
    setAddSectionLoading(true);

    await fetch(`${baseUrl}/global-section`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Section successfully added");
            setAddSectionModal(false);
            setAddSectionLoading(false);
            getSections();
            setSectionName("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddSectionModal(false);
            setAddSectionLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddSectionModal(false);
            setAddSectionLoading(false);
          }
        })
      )
      .catch((err) => {
        setAddSectionLoading(false);
        setAddSectionModal(false);
        console.log(err);
      });
  };

  const getEditSection = async (id) => {
    await fetch(`${baseUrl}/global-section/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditSectionName(data.payload?.name);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateSectionHandler = async () => {
    if (editSectionName == "") {
      return alert.error("Section Name Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: editSectionName,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/global-section/${editSectionId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Section Successfully Updated");
            getSections();
            setEditSectionModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditSectionModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditSectionModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteSectionHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/global-section/${deleteSectionId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getSections();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddSectionModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Section
          </button>
        </div>

        <Table className="mt-5">
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Section Name</th>
              {PremissionChecker(user, "campus.can_change_section") && (
                <th>Update</th>
              )}
              {PremissionChecker(user, "campus.can_change_section") && (
                <th>Delete</th>
              )}
            </tr>
          </thead>
          <tbody>
            {sectionsData?.map((sections, index) => (
              <tr className="text-center" key={index}>
                <td>{sections.id}</td>
                <td>{sections.name}</td>

                {PremissionChecker(user, "campus.can_change_section") && (
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                      onClick={() => {
                        getEditSection(sections?.id);
                        setEditSectionId(sections?.id);
                        setEditSectionModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                )}

                {PremissionChecker(user, "campus.can_change_section") && (
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                      onClick={() => {
                        setDeleteSectionId(sections?.id);
                        setdeleteModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add SectionModal */}
        <Modal show={addSectionModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Section
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Section Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={sectionName}
                onChange={(e) => setSectionName(e.target.value)}
                placeholder="Enter Section Name"
              />
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addSectionLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSectionHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddSectionModal(false);
                setisallfields(false);
                setSectionName("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update SectionModal */}
        <Modal show={editSectionModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Section</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Section Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={editSectionName}
                onChange={(e) => setEditSectionName(e.target.value)}
                placeholder="Enter Section Name"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateSectionHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditSectionModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete  Section Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this section?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Section Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteSectionHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default DefineSection;
